import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &.fullscreen {
    height: calc(100vh - 120px);
  }
  &.normal {
    padding: 40px 0px;
  }
  h1, h2 {
    max-width: 70%;
  }
  h1 {
    font-weight: 800;
    font-size: 22px;
    text-align: center;
  }
  h2 {
    font-size: 14px;
    text-align: center;
  }
  svg {
    font-size: 100px;
  }
  button {
    margin-top: 20px;
  }
`;
